import { render, staticRenderFns } from "./PackagingRoot.vue?vue&type=template&id=bb41d368&scoped=true"
import script from "./PackagingRoot.vue?vue&type=script&lang=js"
export * from "./PackagingRoot.vue?vue&type=script&lang=js"
import style0 from "./PackagingRoot.vue?vue&type=style&index=0&id=bb41d368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb41d368",
  null
  
)

export default component.exports